import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

const parseValue = (value, format, fixed) => {
  switch (format) {
    case 'int': {
      return parseInt(value, 10);
    }
    case 'float': {
      return parseFloat(value).toFixed(fixed);
    }
    case 'round': {
      return Math.round(value);
    }
    default: {
      console.warn(`NumberCellRenderer does't support ${format} format`);
      return 0;
    }
  }
};

const NumberRenderer = ({
  value,
  prefix,
  suffix,
  valueFormat = 'int',
  fixed = 2,
}) => (
  <NumberFormat
    displayType={'text'}
    thousandSeparator
    value={parseValue(value, valueFormat, fixed)}
    prefix={prefix}
    suffix={suffix}
  />
);

NumberRenderer.propTypes = {
  value: PropTypes.any,
  valueFormat: PropTypes.string,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  fixed: PropTypes.any,
};

export default NumberRenderer;
